// VITAMINS page — ported verbatim from the original app's VITAMINS section.
import { S } from '../state.js';
import { save } from '../lib/sync.js';
import { today, fmtDate, shiftDate } from '../lib/dates.js';
import { escHtml } from '../lib/format.js';
import { isRestDay } from '../lib/calc.js';
import { VITS_DEFAULT } from '../data/vitamins.js';
import { IC, cicon } from '../lib/icons.js';
import { openModal, closeModal } from '../lib/modal.js';
import { showConfirm } from '../components/confirmDialog.js';
import { registerPage } from '../lib/router.js';

let vitDate = today();
let forceShownSlots = new Set(); // per-session, per-day "Показать" override — not saved

export function shiftVitDate(n) {
  vitDate = shiftDate(vitDate, n);
  forceShownSlots = new Set();
  renderVitamins();
}
export function setVitDate(d) { vitDate = d; forceShownSlots = new Set(); renderVitamins(); }

export function showVitSlotAnyway(si) {
  forceShownSlots.add(si);
  renderVitamins();
}

export function renderVitamins() {
  document.getElementById('vitDateLabel').textContent = fmtDate(vitDate);
  const cfg = S.vitConfig || VITS_DEFAULT;
  const vits = S.vitamins[vitDate] || {};
  // Master override (Настройка витаминов → "Показывать в выходной день") — when on, the
  // per-item "Пропускать в выходной" flags are ignored entirely and nothing is hidden.
  const restToday = isRestDay(vitDate) && S.settings.showVitOnRest !== true;
  let html = '';
  cfg.slots.forEach((slot, si) => {
    const hideForRest = restToday && !forceShownSlots.has(si);
    const visibleItems = slot.items.map((item, ii) => ({ item, ii })).filter(({ item }) => !(hideForRest && item.skipOnRest));
    if (!visibleItems.length) {
      // Don't just vanish the slot — a slot with items that all got hidden for today looked
      // exactly like a data-loss bug otherwise. Show why, and let it be revealed for today.
      if (slot.items.length) {
        html += `<div class="vit-slot">
          <div class="vit-slot-hd">
            <span class="vit-slot-name slot-dim">${escHtml(slot.name)}${slot.time ? ' · ' + slot.time : ''}</span>
          </div>
          <div class="t-secondary" style="font-size:12px;display:flex;align-items:center;justify-content:space-between;gap:8px">
            <span>${cicon('moon', 13)} Скрыто — выходной день</span>
            <button class="btn btn-ghost btn-xs" onclick="showVitSlotAnyway(${si})">Показать</button>
          </div>
        </div>`;
      }
      return;
    }
    const slotDone = visibleItems.every(({ ii }) => vits[si + '_' + ii]);
    html += `<div class="vit-slot">
      <div class="vit-slot-hd">
        <span class="vit-slot-name ${slotDone ? '' : 'slot-dim'}">${escHtml(slot.name)}${slot.time ? ' · ' + slot.time : ''}</span>
        ${slotDone ? `<span class="tag tag-green">✓ Готово</span>` : ''}
      </div>`;
    visibleItems.forEach(({ item, ii }) => {
      const key = si + '_' + ii;
      const done = !!vits[key];
      const hasStock = item.stock !== undefined && item.stock !== null;
      const lowStock = hasStock && item.stock <= 7;
      html += `<div class="vit-item ${done ? 'vit-done' : ''}">
        <input type="checkbox" class="vit-cb" ${done ? 'checked' : ''} onchange="toggleVit(${si},${ii},this.checked)">
        <div class="vit-body">
          <div class="vit-name">${escHtml(item.name)}</div>
          ${item.desc ? `<div class="vit-desc">${escHtml(item.desc)}</div>` : ''}
          ${hasStock ? `<div class="vit-desc" style="${lowStock ? 'color:var(--amber);font-weight:600' : ''}">${lowStock ? cicon('warning', 12) + ' ' : ''}Осталось: ${item.stock} шт</div>` : ''}
        </div>
        <div class="vit-actions">
          <button class="vit-btn" onclick="openVitItemEdit(${si},${ii})">${IC.edit}</button>
          <button class="vit-btn" onclick="delVitItem(${si},${ii})">${IC.trash}</button>
        </div>
      </div>`;
    });
    html += `<button class="btn btn-ghost btn-sm btn-block" style="margin-top:6px" onclick="openVitItemNew(${si})">+ Добавить</button>`;
    html += `</div>`;
  });
  if (restToday && !html) {
    html = `<div class="empty" style="padding:24px 0"><div class="empty-text">Сегодня выходной — все витамины на сегодня скрыты</div></div>`;
  }
  document.getElementById('vitList').innerHTML = html;
}
registerPage('vitamins', renderVitamins);

export function toggleVit(si, ii, val) {
  if (!S.vitamins[vitDate]) S.vitamins[vitDate] = {};
  const was = !!S.vitamins[vitDate][si + '_' + ii];
  S.vitamins[vitDate][si + '_' + ii] = val;
  // Only adjust stock for today's checkbox — editing history doesn't re-count consumption.
  if (vitDate === today() && S.vitConfig) {
    const item = S.vitConfig.slots[si]?.items[ii];
    if (item && item.stock !== undefined && item.stock !== null) {
      if (val && !was) item.stock = Math.max(0, item.stock - 1);
      else if (!val && was) item.stock = item.stock + 1;
    }
  }
  save(true); renderVitamins();
}

export function saveVitShowOnRest(val) {
  S.settings.showVitOnRest = val;
  save(true);
  renderVitamins();
}

export function openVitConfig() {
  const cfg = S.vitConfig || VITS_DEFAULT;
  document.getElementById('vitShowOnRest').checked = S.settings.showVitOnRest === true;
  let html = cfg.slots.map((slot, si) => `
    <div class="card card-sm" style="margin-bottom:8px">
      <div style="display:flex;gap:8px;margin-bottom:6px">
        <input class="inp" value="${escHtml(slot.name)}" onchange="saveVitSlotField(${si},'name',this.value)" style="flex:1">
        <input class="inp" type="time" value="${slot.time || ''}" onchange="saveVitSlotField(${si},'time',this.value)" style="width:110px" title="Время приёма">
      </div>
      <div style="display:flex;justify-content:space-between;align-items:center">
        <span class="t-secondary" id="vitSlotSaved${si}" style="font-size:11px;color:var(--accent);opacity:0;transition:opacity .3s">✓ Сохранено</span>
        <button class="btn btn-danger btn-xs" onclick="delVitSlot(${si})">Удалить</button>
      </div>
    </div>
  `).join('');
  document.getElementById('vitConfigBody').innerHTML = html;
  openModal('shVitConfig');
}

export function saveVitSlotField(si, field, value) {
  S.vitConfig.slots[si][field] = value;
  save(true); // push immediately — a schedule-affecting edit shouldn't sit in the debounce window
  const badge = document.getElementById('vitSlotSaved' + si);
  if (badge) {
    badge.style.opacity = '1';
    setTimeout(() => { badge.style.opacity = '0'; }, 1500);
  }
}

export function addVitSlot() {
  if (!S.vitConfig) S.vitConfig = JSON.parse(JSON.stringify(VITS_DEFAULT));
  S.vitConfig.slots.push({ name: 'Новый слот', time: '09:00', items: [] });
  save(true); openVitConfig(); renderVitamins();
}

export function delVitSlot(si) {
  showConfirm('Удалить слот?', () => {
    S.vitConfig.slots.splice(si, 1);
    save(true); closeModal('shVitConfig'); renderVitamins();
  });
}

export function openVitItemNew(si) {
  document.getElementById('vitItemTitle').textContent = 'Добавить витамин';
  document.getElementById('viName').value = '';
  document.getElementById('viDesc').value = '';
  document.getElementById('viStock').value = '';
  document.getElementById('viSkipRest').checked = false;
  document.getElementById('viSlot').value = si;
  document.getElementById('viIdx').value = '';
  openModal('shVitItem');
}

export function openVitItemEdit(si, ii) {
  const item = S.vitConfig.slots[si].items[ii];
  document.getElementById('vitItemTitle').textContent = 'Редактировать';
  document.getElementById('viName').value = item.name;
  document.getElementById('viDesc').value = item.desc || '';
  document.getElementById('viStock').value = (item.stock === undefined || item.stock === null) ? '' : item.stock;
  document.getElementById('viSkipRest').checked = !!item.skipOnRest;
  document.getElementById('viSlot').value = si;
  document.getElementById('viIdx').value = ii;
  openModal('shVitItem');
}

export function delVitItem(si, ii) {
  showConfirm('Удалить?', () => {
    S.vitConfig.slots[si].items.splice(ii, 1);
    save(true); renderVitamins();
  });
}

export function saveVitItem() {
  const name = document.getElementById('viName').value.trim();
  if (!name) return;
  const si = parseInt(document.getElementById('viSlot').value);
  const ii = document.getElementById('viIdx').value;
  const stockRaw = document.getElementById('viStock').value;
  const item = { name, desc: document.getElementById('viDesc').value.trim(), stock: stockRaw === '' ? null : parseInt(stockRaw), skipOnRest: document.getElementById('viSkipRest').checked };
  if (ii === '') {
    S.vitConfig.slots[si].items.push(item);
  } else {
    S.vitConfig.slots[si].items[parseInt(ii)] = item;
  }
  save(true); closeModal('shVitItem'); renderVitamins();
}
